import { IonGrid, IonText } from "@ionic/react";
import { useSelector } from "react-redux";
import { SelectedUserInfo } from "../../../@types/SelectedUserInfo";
import { selectSelectedUsersInfoStatus } from "../../../store/massiveDocumentCreate/selectors/selectedUsersInfoStatus";
import { selectSelectedUsersInfo } from "../../../store/massiveDocumentCreate/selectors/selectSelectedUsersInfo";

export const UserTablePreview = ({ title }: { title: string}) => {
    const selectedUsersInfo = useSelector(selectSelectedUsersInfo)
    const status = useSelector(selectSelectedUsersInfoStatus)
    return (
        <>
            <section style={{ display: "flex", overflow: "auto", scrollSnapType: "x mandatory", height: "100%" }}>
                <IonGrid className="ion-margin-start ion-margin-top tabla-preview ion-margin-end">
                    <IonText color="primary">
                        <h2>{title}</h2>
                    </IonText>
                    {selectedUsersInfo.length === 0 &&
                        <IonText>Usuario no tiene ficha generada.</IonText>
                    }

                    <table className="tbl-separate tbl">
                        <tbody>
                            {selectedUsersInfo.length > 0 &&
                                <tr>
                                    <th>ID</th>
                                    <th>Suscripción de Contrato</th>
                                    <th>Nombres</th>
                                    <th>Apellidos</th>
                                    <th>Fecha de Nacimiento</th>
                                    <th>Sexo</th>
                                    <th>Nacionalidad</th>
                                    <th>Dirección</th>
                                    <th>Cargo</th>
                                    <th>Código Servicios</th>
                                    <th>Estado Civil</th>
                                    <th>Ciudad</th>
                                    <th>Comúna</th>
                                    <th>Nombre Servicio</th>
                                    <th>Nombre Cliente</th>
                                    <th>Forma de Pago</th>
                                    <th>Vencimiento Contrato</th>
                                    <th>Día siguiente al VC</th>
                                    <th>Ubicación</th>
                                    <th>Serivicios Ciudad</th>
                                    <th>Fecha Prorroga Contrato</th>
                                    <th>P001</th>
                                    <th>P025</th>
                                    <th>P060</th>
                                    <th>P070</th>
                                    <th>P027</th>
                                    <th>P039</th>
                                    <th>P300</th>
                                    <th>Email</th>
                                    <th>Email validado para firmar</th>
                                </tr>
                            }
                            {status === "pending" &&
                                <p style={{ textAlign: "center" }}>Cargando...</p>
                            }
                            {status === "fulfilled" && selectedUsersInfo.length > 0 && selectedUsersInfo.map((person, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{person.id}</td>
                                        <td>{person.fechaSuscripcionContrato}</td>
                                        <td>{person.nombres}</td>
                                        <td>
                                            {person.apellidoPaterno} {person.apellidoMaterno}
                                        </td>
                                        <td>{person.fechaNacimiento}</td>
                                        <td>{person.sexo}</td>
                                        <td>{person.nacionalidad}</td>
                                        <td>{person.direccion}</td>
                                        <td>{person.cargoNombre}</td>
                                        <td>{person.serviciosCodigo}</td>
                                        <td>{person.estadoCivil}</td>
                                        <td>{person.ciudad}</td>
                                        <td>{person.comuna}</td>
                                        <td>{person.serviciosNombre}</td>
                                        <td>{person.serviciosNombreCliente}</td>
                                        <td>{person.formaPago}</td>
                                        <td>{person.fechaVencimientoContrato}</td>
                                        <td>{person.diaSiguienteVC}</td>
                                        <td>{person.serviciosUbicadoEn}</td>
                                        <td>{person.serviciosCiudad}</td>
                                        <td>{person.fechaProrrogaContrato}</td>
                                        <td>{person.p001}</td>
                                        <td>{person.p025}</td>
                                        <td>{person.p060}</td>
                                        <td>{person.p070}</td>
                                        <td>{person.p027}</td>
                                        <td>{person.p039}</td>
                                        <td>{person.p300}</td>
                                        <td>{person.email}</td>
                                        <td>{person.emailApiGS}</td>
                                    </tr>
                                );
                            })}

                        </tbody>
                    </table>
                </IonGrid>
            </section>
        </>
    )
}
